<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="chapter-title">CONTENTS</h2>
<p class="toc2"> </p>
<p class="toc2"><a href="#/ack">ACKNOWLEDGMENTS</a></p>
<p class="toc1"><a href="#/intro">Introduction: The Work of Interviews</a></p>
<p class="toc2"><a href="#/intro#au">• <i>CAROL MAGEE AND JOANNA GRABSKI</i></a></p>
<p class="toc"><a href="#/chap01">1.  Talking to People about Art</a></p>
<p class="toc2"><a href="#/chap01#au">•<i>PATRICK MCNAUGHTON</i></a></p>
<p class="toc"><span href="#/chap02" title="Link target outside of Sample">2.  Ghostly Stories: Interviews with Artists in Dakar and the Productive Space around Absence</span></p>
<p class="toc2"><span href="#/chap02#au" title="Link target outside of Sample">•<i>JOANNA GRABSKI</i></span></p>
<p class="toc"><span href="#/chap03" title="Link target outside of Sample">3.  Can the Artist Speak?: Hamid Kachmar's <span class="strike">Subversive</span> Redemptive Art of Resistance</span></p>
<p class="toc2"><span href="#/chap03#au" title="Link target outside of Sample">•<i>JOSEPH JORDAN</i></span></p>
<p class="toc"><span href="#/chap04" title="Link target outside of Sample">4.  Photography, Narrative Interventions, and (Cross) Cultural Representations</span></p>
<p class="toc2"><span href="#/chap04#au" title="Link target outside of Sample">•<i>CAROL MAGEE</i></span></p>
<p class="toc"><span href="#/chap05" title="Link target outside of Sample">5.  Narrating the Artist: Seyni Camara and the Multiple Constructions of the Artistic Persona</span></p>
<p class="toc2"><span href="#/chap05#au" title="Link target outside of Sample">•<i>SILVIA FORNI</i></span></p>
<p class="toc"><span href="#/chap06" title="Link target outside of Sample">6.  Interview: Akinbode Akinbiyi</span></p>
<p class="toc2"><span href="#/chap06#au" title="Link target outside of Sample">•<i>AKINBODE AKINBIYI</i></span></p>
<p class="toc"><span href="#/chap07" title="Link target outside of Sample">7.  Interweaving Narratives of Art and Activism: Sandra Kriel's Heroic Women</span></p>
<p class="toc2"><span href="#/chap07#au" title="Link target outside of Sample">•<i>KIM MILLER</i></span></p>
<p class="toc"><span href="#/chap08" title="Link target outside of Sample">8.  Politics of Narrative at the African Burial Ground in New York City: The Final Monument</span></p>
<p class="toc2"><span href="#/chap08#au" title="Link target outside of Sample">•<i>ANDREA E. FROHNE</i></span></p>
<p class="toc"><span href="#/chap09" title="Link target outside of Sample">9.  Who Owns the Past?: Constructing an Art History of a Malian Masquerade</span></p>
<p class="toc2"><span href="#/chap09#au" title="Link target outside of Sample">•<i>MARY JO ARNOLDI</i></span></p>
<p class="toca"><span href="#/chap10" title="Link target outside of Sample">10.  Framing Practices: Artists’ Voices and the Power of Self-Representation</span></p>
<p class="toc2"><span href="#/chap10#au" title="Link target outside of Sample">•<i>CHRISTINE MULLEN KREAMER</i></span></p>
<p class="toca"><span href="#/chap11" title="Link target outside of Sample">11.  Undisciplined Knowledge</span></p>
<p class="toc2"><span href="#/chap11#au" title="Link target outside of Sample">•<i>ALLAN DESOUZA AND ALLYSON PURPURA</i></span></p>
<p class="toc4"><span href="#/back01" title="Link target outside of Sample">APPENDIX: INTERLOCUTORS</span></p>
<p class="toc3"><span href="#/back02" title="Link target outside of Sample">CONTRIBUTORS</span></p>
<p class="toc3"><span href="#/index" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?6e47f94e